import { useState, useEffect, useRef } from 'react'
import { Button } from '@/components/ui/button'
import { usePWA } from '@/hooks/usePWA'

export const InstallPrompt = () => {
    const { isInstallable, isInstalled, isOnline, promptInstall, debugInfo } = usePWA()
    const [isInstalling, setIsInstalling] = useState(false)
    const [isDismissed, setIsDismissed] = useState(
        () => localStorage.getItem('displayBannerDoucheFlux') === 'false'
    )

    console.log("InstallPrompt Debug - PWA Status:", {
        isInstallable,
        isInstalled,
        isOnline,
        debugInfo
    })

    const handleInstall = async () => {
        if (!isInstallable) {
            console.error('InstallPrompt - Cannot install, not installable:', debugInfo)
            return
        }

        setIsInstalling(true)
        try {
            await promptInstall()
        } catch (error) {
            console.error('InstallPrompt - Failed to install app:', error)
        } finally {
            setIsInstalling(false)
        }
    }

    const handleDismiss = () => {
        localStorage.setItem('displayBannerDoucheFlux', 'false')
        setIsDismissed(true)
    }

    const showInstallPrompt = !isInstalled && isInstallable && !isDismissed
    const showOfflineWarning = !isOnline

    // Don't render anything if nothing to show
    if (!showInstallPrompt && !showOfflineWarning) {
        return null
    }

    return (
        <div className="w-full bg-gray-50">
            {/* Install prompt - only show if installable, not installed, and not dismissed */}
            {showInstallPrompt && (
                <div className='p-4'>
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                        <div className="flex items-center justify-between">
                            <div className="flex-1">
                                <h3 className="text-sm font-medium text-blue-900 mb-1">
                                    🚀 Installer l'application
                                </h3>
                                <p className="text-sm text-blue-700">
                                    Installez DoucheFLUX sur votre appareil pour un accès rapide et une utilisation hors de votre navigateur.
                                </p>
                            </div>
                            <div className="ml-4 flex items-center gap-2">
                                <Button
                                    onClick={handleInstall}
                                    disabled={isInstalling}
                                    size="sm"
                                    className="bg-blue-600 hover:bg-blue-700"
                                >
                                    {isInstalling ? 'Installation...' : 'Installer'}
                                </Button>
                                <button
                                    onClick={handleDismiss}
                                    className="text-blue-400 hover:text-blue-600 transition-colors p-1"
                                    aria-label="Fermer"
                                >
                                    <svg
                                        className="w-4 h-4"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Offline warning */}
            {showOfflineWarning && (
                <div className='p-4'>
                    <div className="text-xs text-orange-600 bg-orange-50 p-2 rounded border border-orange-200">
                        ⚠️ Mode hors ligne - Certaines fonctionnalités peuvent être limitées
                    </div>
                </div>
            )}
        </div>
    )
} 